import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowTrendDown,
  faFileInvoiceDollar,
  faMagnifyingGlass,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";

const stats = [
  {
    value: "87%",
    label: "of companies now use AI-driven tools",
  },
  {
    icon: faFileInvoiceDollar,
    value: "30%",
    label: "of reduce hiring costs per hire",
  },
  {
    icon: faMagnifyingGlass,
    value: "49%",
    label: "of candidates believe AI reduce bias hiring",
  },
  {
    icon: faTriangleExclamation,
    value: "66%",
    label: "of organizations report improved hiring efficiencies",
  },
];

const Section2 = ({ url }) => {
  const bgImage =
    "https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=1400&q=70";

  return (
    <section className="home-section-2">
    <div className="container overflow-hidden">
      <div className="section-2-header" data-aos="fade-up">
        <h2 className="section-title">
          From <span className="gradient-text"> 847 Applicants </span> to <br/> <span className="gradient-text"> 5 Qualified Hires </span> in Minutes 
        </h2>
      </div>

      <div className="stats-grid ">

        <div className="stat-card overflow-hidden" data-aos="fade-right" data-aos-delay="600">
 
          <div className="stat-value gradient-text overflow-hidden">21%</div>
          <p className="stat-desc">of Your Bottom Line Is Lost to Document Chaos</p>
        </div>

        <div className="stat-card overflow-hidden" data-aos="zoom-in" data-aos-delay="600">
          <div className="stat-value gradient-text overflow-hidden">$20</div>
          <p className="stat-desc">Per Document: The Hidden Cost of Manual Management</p>
        </div>

        <div className="stat-card overflow-hidden" data-aos="zoom-in" data-aos-delay="600">
          <div className="stat-value gradient-text overflow-hidden" >40-60%</div>
          <p className="stat-desc">of Small Businesses Never Recover After Document Loss</p>
        </div>

        <div className="stat-card overflow-hidden" data-aos="fade-left" data-aos-delay="600">
          <div className="stat-value gradient-text overflow-hidden">47%</div>
          <p className="stat-desc">of Your Workforce Can't Find What They Need to Do Their Jobs</p>
        </div>

      </div>
    </div>
  </section>
  );
};

export default Section2;